export const dependencies: string[] = [
  'authStore',
  'loanStore',
  'appStore',
  'reasonStore',
  'pageStepperStore',
  'loansApi',
  'authApi',
  'borrowerApi',
  'adminApi',
  'documentsApi',
  'widgetApi',
  'borrowerStore',
  'hubService',
  'widgetStore',
  'companyApi',
  'featureFlagApi',
  'companyStore'
];

// Route the Sprout HR dashboard opens in its own modal for the KYC form
// (b.ii.2). HR concatenates this straight into the iframe URL — see
// Parent.openParentModal — so it must match the path registered in utils/router.
export const KYC_ROUTE = 'kyc-form';
